module.exports = __webpack_public_path__ + "static/leafshyp-af2f0734bb173137d4688627352f9355.png";